import { useContext, useEffect, useState, ReactElement } from 'react';
import { Category } from '../types/catalog';
import { CategoriesContext } from '../App';

export interface MenuItemRenderProps extends Category {
    isOpen: boolean;
    onOpen: () => void;
    hasChildren: boolean;
    isCurrentPath: boolean;
}

interface MenuItemProps extends Category {
    render: (props: MenuItemRenderProps) => ReactElement | null;
    defaultIsOpen?: boolean;
}

const MenuItem = ({ render, defaultIsOpen = false, ...cat }: MenuItemProps) => {
    const { children, slugPath, url } = cat;
    const { pathname, fetchCategoryChildren } = useContext(CategoriesContext);
    const [isOpen, setIsOpen] = useState(defaultIsOpen);
    const onOpen = () => {
        const next = !isOpen;
        setIsOpen(next);
        if (next && children?.some((c) => !c.children)) {
            fetchCategoryChildren(slugPath);
        }
    };
    const hasChildren = !!children?.length;
    const isCurrentPath = pathname.startsWith(url);
    useEffect(() => {
        if (isCurrentPath && hasChildren) {
            setIsOpen(true);
        }
    }, [isCurrentPath, hasChildren]);
    const Component = render;
    return (
        <Component
            isOpen={isOpen}
            onOpen={onOpen}
            hasChildren={hasChildren}
            isCurrentPath={isCurrentPath}
            {...cat}
        />
    );
};

export default MenuItem;
